import { render, staticRenderFns } from "./SetPricesOnSizesStep.vue?vue&type=template&id=5bbeea0a&scoped=true&"
import script from "./SetPricesOnSizesStep.vue?vue&type=script&lang=js&"
export * from "./SetPricesOnSizesStep.vue?vue&type=script&lang=js&"
import style0 from "./SetPricesOnSizesStep.vue?vue&type=style&index=0&id=5bbeea0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbeea0a",
  null
  
)

export default component.exports